import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ViewCvComponent } from '../view-cv/view-cv.component';
import { JobsOffersApplicant } from '../models/jobs-offers-applicant';
import { Constants } from '../constants';

@Component({
  selector: 'app-item-candidate',
  templateUrl: './item-candidate.component.html',
  styleUrls: ['./item-candidate.component.css']
})
export class ItemCandidateComponent implements OnInit {
  @Input() user;
  @Input() index;
  @Input() check_mandatory;
  @Input() job;
  @Input() listtype;

  selectedOption;

  public STATUS = Constants;

  constructor(public dialog: MatDialog) {
    if (this.check_mandatory !== undefined) {
      this.check_mandatory = true;
    }
  }

  ngOnInit() {
    console.log(this.user);
  }

  openCV(userId) {
    if (this.job.status !== -4) {
      console.log(this.job);
      console.log(this.listtype);
      console.log(this.user.status);
      const dialogRef = this.dialog.open(ViewCvComponent, {
        data: {
          selected: userId,
          requirement: false,
          jobInvite: this.job.id,
          listType: this.listtype,
          status: this.user.status.id,
          filters: []
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        this.selectedOption = result;
      });
    }
  }

  //noinspection JSMethodCanBeStatic
  percMandatory(user): number {
    if (user.apply !== undefined) {
      if (user.apply.mandatoryrequirements > 0) {
        return Math.floor(user.apply.mandatoryrequirementsmet / user.apply.mandatoryrequirements * 100);
      } else {
        return 0;
      }
    } else {
      if (user.mandatoryrequirements > 0) {
        return Math.floor(user.mandatoryrequirementsmet / user.mandatoryrequirements * 100);
      } else {
        return 0;
      }
    }
  }

  //noinspection JSMethodCanBeStatic
  percDesirable(user): number {
    if (user.apply !== undefined) {
      if (user.apply.desirablerequirements > 0) {
        return Math.floor(user.apply.desirablerequirementsmet / user.apply.desirablerequirements * 100);
      } else {
        return 0;
      }
    } else {
      if (user.desirablerequirements > 0) {
        return Math.floor(user.desirablerequirementsmet / user.desirablerequirements * 100);
      } else {
        return 0;
      }
    }
  }
}



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/item-candidate/item-candidate.component.ts